<div class="investment">
  @if (loading) {
    <div class="state" role="status"><i class="fa-solid fa-circle-notch fa-spin" aria-hidden="true"></i> Loading investment data...</div>
  } @else if (report) {
    @if (rentalMetrics.length) {
    <section class="section">
      <span class="eyebrow">Returns</span>
      <h2><i class="fa-solid fa-chart-line" aria-hidden="true"></i> Rental &amp; ROI Intelligence</h2>
      <div class="metrics rental-metrics">
        @for (metric of rentalMetrics; track metric.label) {
          <div class="metric"><span>{{ metric.label }}</span><strong>{{ metric.value }}</strong></div>
        }
      </div>
    </section>

    }
    @if (scores.length) {
    <section class="section">
      <span class="eyebrow">Score</span>
      <h2><i class="fa-regular fa-circle-check" aria-hidden="true"></i> Investment Score Breakdown</h2>
      <div class="scores">
        @for (score of scores; track score.label) {
          <div class="score">
            <div><span>{{ score.label }}</span><strong>{{ score.score }}/100</strong></div>
            <div class="score-track" role="meter" [attr.aria-label]="score.label" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="score.score"><div [style.width.%]="score.score"></div></div>
          </div>
        }
      </div>
    </section>

    }

    @if (evidence.length) {
      <section class="section">
        <span class="eyebrow">Investor Intelligence</span>
        <h2><i class="fa-solid fa-chart-line" aria-hidden="true"></i> Pricing Evidence</h2>
        <div class="metrics rental-metrics">
          @for (metric of evidence; track metric.label) {
            <div class="metric"><span>{{ metric.label }}</span><strong>{{ metric.value }}</strong></div>
          }
        </div>
      </section>
    }
    @if (!rentalMetrics.length && !scores.length && !evidence.length) {
      <div class="state" role="status">Investment data is not available for this property yet.</div>
    }

  } @else {
    <div class="state" role="status"><i class="fa-regular fa-file-lines" aria-hidden="true"></i>{{ error || 'CI data is not available for this property yet.' }}</div>
  }
</div>
